export const UPDATE_EXPORT_ACTIVE = 'REPORTING_UPDATE_EXPORT_ACTIVE';

export const updateExportActive = exportActive => ({
  type: UPDATE_EXPORT_ACTIVE,
  exportActive,
});
